import React, { useEffect, useRef, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { lomavisCreatorRootState } from '../../../../pages/lomavisCreator';
import { useTranslate } from '@tolgee/react';

import { Button, ProgressBar } from 'react-bootstrap';
import { getValidMimeType } from '../../utils/helpers';

import { IMAGE, PREVIEW_TYPE_STANDARD, VIDEO } from '../../config/constants';
import Carousel from './Carousel';

import VideoComponent from '../SocialMediaCards/VideoComponent';
import PdfComponent from '../SocialMediaCards/PdfComponent';

export default function MediaViewer({
  startSubmission,
  footerRef,
  rightMargin,

  mediaFiles,
  handleClose,

  setSelectedIndex,
  selectedIndex,
  mediaType
}) {
  const { t } = useTranslate();
  const dispatch = useDispatch();

  const selectedFile = mediaFiles[selectedIndex];

  const [processingImage, setProcessingImage] = useState(false);

  const [editorChanged, setEditorChanged] = useState(false);

  return (
    <div className="d-flex w-100 h-100 flex-column gap-4 ">
      <div className="d-flex w-100 gap-4 flex-grow-1 overflow-hidden ">
        <div
          style={{ width: '140px' }}
          className="bg-white p-2 rounded-3 mx-auto d-flex flex-column justify-content-center h-100"
        >
          <Carousel
            items={mediaFiles}
            setSelectedIndex={setSelectedIndex}
            selectedFile={selectedFile}
            setEditorChanged={setEditorChanged}
            editorChanged={editorChanged}
          />
        </div>

        <div
          // style={{ minHeight: "500px" }}
          className="flex-grow-1 overflow-auto"
        >
          <div className=" w-100 h-100 position-relative d-flex flex-column gap-4 ">
            <div className="w-100 bg-white p-3 h-100 rounded-3">
              {selectedFile ? (
                <div
                  style={{
                    width: '100%',
                    height: '100%'
                  }}
                  className="mx-auto align-items-center justify-content-center d-flex flex-column gap-4"
                >
                  {mediaType === IMAGE ? (
                    <div className="w-100 h-100 position-relative">
                      <img
                        style={{
                          maxHeight: '100%',
                          maxWidth: '100%'
                        }}
                        className="position-absolute top-50 start-50 translate-middle object-fit-contain"
                        src={
                          mediaFiles[selectedIndex].assetBlob
                            ? mediaFiles[selectedIndex].assetBlob
                            : mediaFiles[selectedIndex].original_asset
                        }
                        alt="Image preview"
                      />
                    </div>
                  ) : mediaType === VIDEO ? (
                    <div
                      style={{
                        maxWidth: '90%',
                        maxHeight: '90%',
                        width: '100%',
                        height: '100%'
                      }}
                      className="mx-auto align-items-center justify-content-center d-flex flex-column gap-4"
                    >
                      <VideoComponent
                        posterUrl={selectedFile?.thumbnail_image}
                        videoUrl={selectedFile?.original_asset}
                        preview={false}
                        styles={{
                          maxHeight: '100%',
                          maxWidth: '100%',
                          width: '100%',
                          height: '100%',
                          objectFit: 'contain',
                          display: 'block'
                        }}
                      />
                    </div>
                  ) : (
                    <div
                      style={{
                        height: '100%',
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        overflow: 'auto'
                      }}
                      className="position-relative d-flex align-items-center"
                    >
                      <PdfComponent
                        url={
                          mediaFiles[selectedIndex].assetBlob
                            ? mediaFiles[selectedIndex].assetBlob
                            : mediaFiles[selectedIndex].original_asset
                        }
                        previewMode={PREVIEW_TYPE_STANDARD}
                      />
                    </div>
                  )}
                </div>
              ) : (
                <div className="h-100 w-100 d-flex justify-content-center align-items-center">
                  {t('lomavisCreator.noData')}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div
        ref={footerRef}
        style={{ bottom: '0', zIndex: 100, height: '60px' }}
        className="w-100 d-flex justify-content-end gap-3 rounded-3 align-items-center bg-white py-2 px-3 border-top h-60px bg-white"
      >
        <div
          style={{ marginRight: rightMargin + 'px' }}
          className="d-flex justify-content-end gap-3 align-items-center py-2 flax-fill"
        >
          {!startSubmission && !processingImage && (
            <Button
              onClick={() => {
                handleClose();
              }}
              variant="secondary"
              size="sm"
              disabled={startSubmission || processingImage}
            >
              {t('lomavisCreator.close')}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
